import { Button } from "react-bootstrap";
import styles from "../Header.module.scss";

const PortfolioInfo = ({
  portfolioPrice,
  portfolioStartPrice,
  updatePortfolioData,
  portfolioData,
  lgShow,
}) => {
  return (
    <div>
      {Number(portfolioPrice.toFixed(2))}
      {" USD "} {portfolioPrice > portfolioStartPrice ? "+" : ""}
      {Number(portfolioPrice - portfolioStartPrice).toFixed(2)}
      {" ("}
      {portfolioPrice
        ? Number(
            ((portfolioPrice - portfolioStartPrice) / portfolioPrice) * 100
          ).toFixed(2)
        : 0}
      {" %)"}
      {lgShow && (
        <Button
          className={styles.updateButton}
          onClick={() => updatePortfolioData(portfolioData)}
          variant="info"
        >
          Update
        </Button>
      )}
    </div>
  );
};

export default PortfolioInfo;
